/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class TaxCountForm {
  public limit: number;
  public offset: number;
  public keyword: string;
  public count: number;

  constructor(taxCountForm: any) {
    this.limit = taxCountForm.limit || 0;
    this.offset = taxCountForm.offset || 0;
    this.keyword = taxCountForm.keyword || '';
    this.count = taxCountForm.count || 0;
  }
}
